// removed by extract-text-webpack-plugin
module.exports = {"letterHeader":"letterHeader--3Lh3Y","terms":"terms--3AUJ2"};